<template lang="pug">
button-base.button-menu(@click='clickEvent')
  image-base(:src='require("@/assets/img/menu_icon.png")')
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * メニューボタン
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
  },
})
export default class ButtonMenu extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-menu
  width 40px
  height var(--input-height-default)
  padding 7px 9px
  background-color var(--color-input-menu__background)
  border 1px solid var(--color-input-menu__border)
  border-radius 10px
</style>
